// Cold-weather / comfort-food stubs — soups, braises, slow stuff.
// Surface in winter months and on rainy days.

export const COLD_WEATHER_STUBS = [
  {
    id: "chicken-noodle-soup",
    title: "Chicken Noodle Soup",
    emoji: "🍲",
    blurb: "Brothy, herby, big bowl of better",
    discoveryTags: ["cold-weather", "rainy-day", "comfort-food", "weeknight", "kids"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 45,
    keyIngredients: ["chicken_breast", "chicken_stock", "egg_noodles", "carrots", "celery", "onion"],
    buildHint: "build the broth right — sauté aromatics, simmer chicken in stock 20 min, shred, add noodles last 8 min so they don't blow out",
    producesCanonical: null,
  },
  {
    id: "tomato-soup",
    title: "Tomato Soup",
    emoji: "🍅",
    blurb: "Velvet-rich tomato with grilled cheese soldiers",
    discoveryTags: ["cold-weather", "rainy-day", "comfort-food", "weeknight", "kids"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 35,
    keyIngredients: ["tomatoes", "onion", "butter", "heavy_cream", "basil"],
    buildHint: "roast canned San Marzanos with onion for depth, blend with butter for silk, finish with cream and torn basil, serve with grilled cheese",
    producesCanonical: null,
  },
  {
    id: "beef-stew",
    title: "Classic Beef Stew",
    emoji: "🥘",
    blurb: "Wine-braised beef with root vegetables",
    discoveryTags: ["cold-weather", "comfort-food", "sunday-dinner", "make-ahead"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 180,
    keyIngredients: ["beef_chuck", "carrots", "potatoes", "onion", "beef_stock", "red_wine"],
    buildHint: "sear meat aggressively for fond, deglaze with wine, braise low 2.5 hours until fork-tender, add potatoes last hour so they don't disintegrate",
    producesCanonical: null,
  },
  {
    id: "chili-con-carne",
    title: "Beef Chili",
    emoji: "🌶️",
    blurb: "Slow-simmered beef and beans with deep spice",
    discoveryTags: ["cold-weather", "comfort-food", "game-day", "superbowl", "sunday-dinner", "make-ahead", "meal-prep"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 90,
    keyIngredients: ["ground_beef", "tomatoes", "kidney_beans", "onion", "chili_powder", "cumin"],
    buildHint: "toast spices in fond after browning beef, layer onion + tomato + beans, simmer 1+ hour for depth, finish with lime and toppings bar",
    producesCanonical: null,
  },
  {
    id: "macaroni-and-cheese",
    title: "Mac and Cheese",
    emoji: "🧀",
    blurb: "Béchamel-rich, baked golden, crisp top",
    discoveryTags: ["cold-weather", "comfort-food", "kids", "weeknight", "sunday-dinner", "thanksgiving"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 40,
    keyIngredients: ["pasta", "cheddar", "milk", "butter", "flour"],
    buildHint: "real béchamel base — butter + flour roux, whisk in warm milk, melt cheese off heat for no break, optional buttered breadcrumb top under broiler",
    producesCanonical: null,
  },
  {
    id: "chicken-pot-pie",
    title: "Chicken Pot Pie",
    emoji: "🥧",
    blurb: "Creamy filling under flaky golden crust",
    discoveryTags: ["cold-weather", "comfort-food", "sunday-dinner", "kids"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 75,
    keyIngredients: ["chicken_breast", "puff_pastry", "carrots", "peas", "onion", "heavy_cream", "chicken_stock"],
    buildHint: "blonde roux thickens the filling, simmer veg and chicken in stock + cream, top with puff pastry and brush with egg wash for shine",
    producesCanonical: null,
  },
];
